import ColumnTypes from '../ReactComponent/SortableTable/constants';

export const FORM_FIELDS = {
  FILTER_ACCT_NUMBERS: 'filterAccountNumbers',
};

export const columns = [
  {
    id: 1,
    label: '',
    field: 'actions',
    sort: false,
    selected: true,
    default: true,
  },
  {
    id: 2,
    label: 'BillOfPayment',
    field: 'probillNumber',
    sort: true,
    selected: true,
    default: true,
    disabled: true,
  },
  {
    id: 3,
    label: 'DeliveryDate',
    field: 'deliveryDate',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 4,
    label: 'From',
    field: 'from',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 5,
    label: 'To',
    field: 'to',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 6,
    label: 'Status',
    field: 'status',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 7,
    label: 'ProofOfDeliveryNo',
    field: 'pod',
    sort: true,
    selected: false,
    default: false,
  },
  {
    id: 8,
    label: 'BillOfLading',
    field: 'bol',
    sort: true,
    selected: false,
    default: false,
  },
  {
    id: 9,
    label: 'ShipmentDate',
    field: 'shipmentDate',
    sort: true,
    selected: false,
    default: false,
  },
  {
    id: 10,
    label: 'DeliveryOrigin',
    field: 'deliveryOrigin',
    sort: true,
    selected: false,
    default: false,
  },
  {
    id: 11,
    label: 'DeliveryDestination',
    field: 'deliveryDestination',
    sort: true,
    selected: false,
    default: false,
  },
  {
    id: 12,
    label: 'PalletsInDelivery',
    field: 'palletsInDelivery',
    sort: true,
    selected: false,
    default: false,
  },
  {
    id: 13,
    label: 'PiecesInDelivery',
    field: 'piecesInDelivery',
    sort: true,
    selected: false,
    default: false,
  },
  {
    id: 14,
    label: 'WeightOfDelivery',
    field: 'weightOfDelivery',
    sort: true,
    selected: false,
    default: false,
  },
  {
    id: 15,
    label: 'Charge',
    field: 'charge',
    sort: true,
    selected: false,
    default: false,
    type: ColumnTypes.Currency,
  },
];

export const defaultShipmentColumns = [
  {
    id: 1,
    label: '',
    field: 'actions',
    sort: false,
    selected: true,
    default: true,
  },
  {
    id: 2,
    label: 'BillOfPayment',
    field: 'probillNumber',
    sort: true,
    selected: true,
    default: true,
    disabled: true,
  },
  {
    id: 3,
    label: 'From',
    field: 'from',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 4,
    label: 'To',
    field: 'to',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 5,
    label: 'Status',
    field: 'status',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 6,
    label: 'DeliveryDate',
    field: 'deliveryDate',
    sort: true,
    selected: true,
    default: true,
  },
];
export const defaultDraftColumns = [
  {
    id: 1,
    label: '',
    field: 'actions',
    sort: false,
    selected: true,
    default: true,
  },
  {
    id: 2,
    label: 'ShipmentId',
    field: 'shipmentId',
    sort: true,
    selected: true,
    default: true,
    disabled: true,
  },
  {
    id: 3,
    label: 'CreateDate',
    field: 'createDate',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 4,
    label: 'From',
    field: 'from',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 5,
    label: 'To',
    field: 'to',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 6,
    label: 'Status',
    field: 'status',
    sort: true,
    selected: true,
    default: true,
  },
];

export const SHIPMENT_REPORT_DATE_RANGE = Object.freeze({
  MIN: new Date(2023, 0, 1, 0, 0, 0),
  MAX: new Date(),
});
